import { render, staticRenderFns } from "./SalaryAdvanceInput.vue?vue&type=template&id=456665b5&"
import script from "./SalaryAdvanceInput.vue?vue&type=script&lang=js&"
export * from "./SalaryAdvanceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports